import gql from 'graphql-tag'

export const statPoliciesByBook = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesByBook(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        bookId
        bookName
        allIds
        borIds
        renewalIds
        rewriteIds
        remarketIds
        newBusinessIds
        cancelledIds
        endorsementIds
        totalPremium
        totalCommission
        totalCommissionReceived
      }
    }
  }
`

export const statPoliciesByCarrier = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesByCarrier(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        id
        name
        policyIds
      }
    }
  }
`

export const statPoliciesByProduct = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesByProduct(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        id
        name
        policyIds
      }
    }
  }
`

export const statPoliciesByRecordType = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesByRecordType(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        id
        name
        policyIds
      }
    }
  }
`

export const statPoliciesBySource = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesBySource(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        id
        name
        policyIds
      }
    }
  }
`

export const statPoliciesByGA = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesByGA(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        id
        name
        policyIds
      }
    }
  }
`
export const statAccountsByMonth = gql`
  query($startDate: String!, $endDate: String!) {
    statAccountsByMonth(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      stats {
        bookId
        bookName
        totalCount
      }
    }
  }
`

export const statPoliciesByType = gql`
  query($startDate: String!, $endDate: String!) {
    statPoliciesByType(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      year
      month
      all
      renew
      cancelled
      endorsement
    }
  }
`

export const statSourceEfficiency = gql`
  query($startDate: String!, $endDate: String!) {
    statSourceEfficiency(
      startDate: $startDate,
      endDate: $endDate,
    ) {
      sourceId
      sourceName
      proportion
    }
  }
`
